import React from 'react';

export const MinimalistTemplate = ({ data }) => {
  return (
    <div className="bg-white h-full min-h-[297mm] p-10 mx-auto text-sm leading-relaxed text-gray-800 font-sans">
        {/* Header */}
        <div className="border-b-2 border-gray-800 pb-4 mb-6">
            <h1 className="text-4xl font-bold uppercase tracking-wider">{data.personalInfo.firstName} {data.personalInfo.lastName}</h1>
            <div className="flex flex-wrap gap-4 mt-2 text-gray-600">
                {data.personalInfo.email && <span>{data.personalInfo.email}</span>}
                {data.personalInfo.phone && <span>| {data.personalInfo.phone}</span>}
                {data.personalInfo.linkedin && <span>| {data.personalInfo.linkedin}</span>}
            </div>
        </div>

        {/* Summary */}
         {data.personalInfo.summary && (
            <div className="mb-6">
                <h2 className="text-lg font-bold uppercase tracking-widest border-b border-gray-300 mb-2">Professional Summary</h2>
                <p>{data.personalInfo.summary}</p>
            </div>
        )}

        {/* Dynamic Sections */}
        {data.sectionsOrder.map((sectionId) => {
            // Experience
            if (sectionId === 'experience' && data.experience.length > 0) {
                return (
                    <div key={sectionId} className="mb-6">
                        <h2 className="text-lg font-bold uppercase tracking-widest border-b border-gray-300 mb-2">Experience</h2>
                        {data.experience.map((exp) => (
                            <div key={exp.id} className="mb-4">
                                <div className="flex justify-between items-baseline mb-1">
                                    <h3 className="font-bold text-base">{exp.role}</h3>
                                    <span className="text-gray-500 italic">{exp.startDate} - {exp.endDate}</span>
                                </div>
                                <p className="font-semibold text-gray-700 mb-1">{exp.company}</p>
                                <p className="whitespace-pre-wrap">{exp.description}</p>
                            </div>
                        ))}
                    </div>
                );
            }

            // Education
            if (sectionId === 'education' && data.education.length > 0) {
                return (
                    <div key={sectionId} className="mb-6">
                        <h2 className="text-lg font-bold uppercase tracking-widest border-b border-gray-300 mb-2">Education</h2>
                        {data.education.map((edu) => (
                            <div key={edu.id} className="mb-2 flex justify-between">
                                <div>
                                    <h3 className="font-bold">{edu.school}</h3>
                                    <p>{edu.degree}</p>
                                </div>
                                <span className="text-gray-500 italic">{edu.year}</span>
                            </div>
                        ))}
                    </div>
                );
            }

            // Skills
            if (sectionId === 'skills' && data.skills.length > 0) {
                return (
                    <div key={sectionId} className="mb-6">
                        <h2 className="text-lg font-bold uppercase tracking-widest border-b border-gray-300 mb-2">Skills</h2>
                        <div className="flex flex-wrap gap-2">
                            {data.skills.map((skill, index) => (
                                <span key={index} className="bg-gray-100 px-3 py-1 rounded-full text-gray-800 text-xs font-semibold">{skill}</span>
                            ))}
                        </div>
                    </div>
                );
            }

            // Custom Sections
            const customSection = data.customSections.find(s => s.id === sectionId);
            if (customSection && customSection.items.length > 0) {
                return (
                    <div key={sectionId} className="mb-6">
                        <h2 className="text-lg font-bold uppercase tracking-widest border-b border-gray-300 mb-2">{customSection.title}</h2>
                        {customSection.items.map((item) => (
                            <div key={item.id} className="mb-4">
                                <h3 className="font-bold text-base">{item.name}</h3>
                                {item.link && <a href={`https://${item.link}`} target="_blank" rel="noreferrer" className="text-blue-600 text-sm hover:underline block mb-1">{item.link}</a>}
                                <p className="whitespace-pre-wrap text-gray-700">{item.description}</p>
                            </div>
                        ))}
                    </div>
                );
            }

            return null;
        })}


    </div>
  );
};
